import { Fragment } from "react";

import CopyFieldIcon from "components/CopyField/Icon";
import Box from "ds/components/Box";
import Link from "ds/components/Link";
import PageInfoHeaderTitle from "ds/components/PageInfoHeader/Title";
import TextEllipsis from "ds/components/TextEllipsis";

import styles from "./styles.module.css";
import useFilesNavigation from "../useFilesNavigation";
import { buildPathSearch } from "../../../helpers";

const SpaceliftVcsRepoFilesTitle = () => {
  const { folderPathSegments, folderPath, setCurrentPath } = useFilesNavigation();

  if (folderPathSegments.length === 0) {
    return <PageInfoHeaderTitle title="Files" />;
  }

  const folderLink = `${window.location.origin}${window.location.pathname}${buildPathSearch(folderPath)}`;

  return (
    <Box direction="row" align="center" gap="small" wrap zeroMinWidth>
      <PageInfoHeaderTitle
        title={
          <Link size="inherit" inheritFont variant="secondary" onPress={() => setCurrentPath([])}>
            Files
          </Link>
        }
      />

      {folderPathSegments.map((segment, i) => {
        const isLast = i === folderPathSegments.length - 1;

        return (
          <Fragment key={i}>
            <PageInfoHeaderTitle title="/" titleTag="span" />
            {isLast ? (
              <Box direction="row" align="center" gap="small" className={styles.lastSegment}>
                <TextEllipsis tooltip={segment}>
                  {(props) => (
                    <PageInfoHeaderTitle
                      titleTag="span"
                      title={
                        <span className={styles.segment} {...props}>
                          {segment}
                        </span>
                      }
                    />
                  )}
                </TextEllipsis>
                <CopyFieldIcon title="Copy link to folder" value={folderLink} variant="ghost" />
              </Box>
            ) : (
              <PageInfoHeaderTitle
                titleTag="span"
                title={
                  <Link
                    size="inherit"
                    inheritFont
                    variant="secondary"
                    onPress={() => setCurrentPath(folderPathSegments.slice(0, i + 1))}
                    className={styles.segment}
                  >
                    {segment}
                  </Link>
                }
              />
            )}
          </Fragment>
        );
      })}
    </Box>
  );
};

export default SpaceliftVcsRepoFilesTitle;
